import { lazy } from 'react';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  PASSWORD_RECOVERY: '/recovery-password',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  MANIFIESTOS: '/manifiestos',
  GUIAS: '/guias',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

// Lazy loaded pages
export const LazyPages = {
  Login: lazy(() =>
    import('@/features/auth').then((module) => ({
      default: module.LoginPage,
    }))
  ),
  PasswordRecovery: lazy(() =>
    import('@/features/auth').then((module) => ({
      default: module.PasswordRecoveryPage,
    }))
  ),
  ForgotPassword: lazy(() =>
    import('@/features/auth').then((module) => ({
      default: module.ForgotPasswordPage,
    }))
  ),
  ResetPassword: lazy(() =>
    import('@/features/auth').then((module) => ({
      default: module.ResetPasswordPage,
    }))
  ),
  Dashboard: lazy(() =>
    import('@/features/dashboard').then((module) => ({
      default: module.DashboardPage,
    }))
  ),
  Manifiestos: lazy(() =>
    import('@/features/manifests').then((module) => ({
      default: module.DocumentosPage,
    }))
  ),
  Documentos: lazy(() =>
    import('@/features/guide').then((module) => ({
      default: module.GuidesPage,
    }))
  ),
} as const;

// Preload function for better UX
export function preloadRoute(page: keyof typeof LazyPages) {
  const component = LazyPages[page];
  if ('preload' in component && typeof component.preload === 'function') {
    component.preload();
  }
}

